const jobsData = [
  { id: 1, title: "Backend Developer", company: "ServerStack", location: "On-site", type: "Full-time" },
  { id: 2, title: "Data Analyst Intern", company: "DataDriven", location: "Remote", type: "Internship" },
  { id: 3, title: "DevOps Engineer", company: "CloudOps", location: "On-site", type: "Full-time" },
  { id: 4, title: "Frontend Developer", company: "UIWorks", location: "Remote", type: "Full-time" },
  { id: 5, title: "Angular Developer", company: "UIWorks", location: "Remote", type: "Full-time" }
];

export default jobsData;